export type ProcessStatusByName = Record<ProcessName, ProcessStatus>;

export interface ProcessStatus {
  startTime?: string,
  statusName?: ProcessStatusName,
  maxFileDuration?: number,
  maxFileDurationName?: string,
  duration?: 25152,
  endTime?: string,
}

export enum ProcessName {
  Ocr = 'OCR',
  GeneralInfo = 'GetGeneralInfo',
  Adls = 'adls',
  Behaviors = 'behavior',
  SpecialNeeds ='behavior',
  Conditions = 'condition',
  HighCostMedications = 'highCostMedications',
  Comprehend = 'comprehend',
  LivingConditions = 'livingCondition',
  OtherImportantMeds = 'otherImportantMeds',
  Summary = 'summary'
}

export enum ProcessStatusName {
  Done = 'Done',
  InProgress = 'In progress',
  Error = 'Error',
}
